import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalVariables } from 'global-variables';
import { Observable } from 'rxjs';
import { saveAs } from 'file-saver';

@Injectable({
  providedIn: 'root'
})
export class UtilityService {

  private url = GlobalVariables.appURL;

  constructor(private _httpClient: HttpClient) { }

  public getCountryList(): Observable<any> {
    return this._httpClient.get(this.url + 'countries');
  }

  public getStatesList(countryId: string): Observable<any> {
    return this._httpClient.get(this.url + 'states/country/' + countryId);
  }

  public getCityList(stateId: string): Observable<any> {
    return this._httpClient.get(this.url + 'cities/state/' + stateId);
  }

  public getCurrencyList(): any {
    return this._httpClient.get(this.url + 'currencies');
  }

  public getConstantList(constantType: any): any {
    return this._httpClient.get(this.url + 'constants/constantType/' + constantType);
  }

  public getCategories(): any {
    return this._httpClient.get(this.url + 'category');
  }

  //  public getSubcategoriesByCategory(categoryId: string): Observable<any> {
  //   return this._httpClient.get(this.url + `/subcategories/category/${categoryId}`);
  // }

   public getSubcategoriesByCategory(categoryId : any): Observable<any> {
    return this._httpClient.get(this.url + `/subcategory/${categoryId }` );
  }

  public getConstants(filter: any): Observable<any> {
    return this._httpClient.get(this.url + 'constants/', {
      params: new HttpParams().set('filter', JSON.stringify(filter))
    });
  }
  public getProductDetails(id:any, featuredOnly: boolean = true): Observable<any> {
    return this._httpClient.get(this.url + 'products/feature/organization/' + id, {
      params: new HttpParams().set('featuredOnly', String(featuredOnly)),
    })
  }

  public getTimeZoneList(): any {
    return this._httpClient.get(this.url + 'timezones');
  }

  downloadFile(url: string, fileName: string) {
    this._httpClient.get(url, { responseType: 'blob' }).subscribe({
      next: (blob) => {
        saveAs(blob, fileName);
      },
      error: (error) => {
        console.error('Download error:', error);
      }
    });
  }
}
